'use strict';

var docsValidateCtrl = [
    '$state', '$scope', '$uibModal', 'toast', 'Integration', "$sce", '$serverData', '$http', 'myTenant', 'Authentication', '$q',
    function ($state, $scope, $uibModal, toast, Integration, $sce, $serverData, $http, myTenant, Authentication, $q) {
        var _this = this;
        this.tenantId = undefined;
        this.filesList = []; // {fileName, fileUrl, filename}
        this.isUploading = false;
        
        if (!Array.isArray(this.model)) {
            this.model = this.model ? [this.model] : [];
        }
        
        // tenantId
        myTenant.load().then(function() {
            _this.tenantId = myTenant.get().id;
        });
        
        // Procesar el modelo inicial para construir la lista de archivos
        if (this.model && this.model.length > 0) {
            this.filesList = this.model.map(function(fileUrl) {
                if (typeof fileUrl === 'string') {
                    // Extraer el nombre del archivo de la URL
                    let urlParts = fileUrl.split('/');
                    let filename = urlParts[urlParts.length - 1];
                    // Limpiar query parameters si existen
                    filename = filename.split('?')[0];
                    return {
                        fileName: filename || 'Archivo subido',
                        fileUrl: fileUrl,
                        filename: filename
                    };
                }
                return fileUrl; // Si ya es un objeto, mantenerlo
            });
        }

        this.selectFile = function () {
            let input = document.createElement('input');
            input.type = 'file';
            input.multiple = true; // Permitir selección múltiple
            input.style.display = 'none';
            document.body.appendChild(input);
            
            input.addEventListener('change', function () {
                let files = Array.from(input.files);
                if (files.length > 0) {
                    files.forEach(function(file) {
                        _this.uploadFile(file);
                    });
                }
                document.body.removeChild(input);
            });
            
            input.click();
        };

        this.uploadFile = function (file) {
            if (!file || !_this.tenantId) {
                if (!_this.tenantId) {
                    toast.error("Error: No se pudo obtener el tenantId.");
                }
                return;
            }

            _this.isUploading = true;

            let timestamp = new Date().getTime();
            let fd = new FormData();
            const hostApi = $serverData.server;
            
            // Generar nombre único para el archivo
            let ext = file.name.slice(file.name.lastIndexOf('.') + 1);
            let uniqueName = `docs-${_this.item.id}-${timestamp}.${ext}`;
            fd.append('file', file, uniqueName);

            // Upload URL: api/containers/{tenantId}/upload/
            $http.post(hostApi.concat('/containers/', _this.tenantId, '/upload/'), fd, {
                headers: { 'Content-Type': undefined },
                transformRequest: angular.identity
            }).then(function (res) {
                let fileResult = res.data.result.files.file[0];
                let filename = fileResult.name;
                
                // Download URL: api/containers/{tenantId}/download/{filename}
                let fileUrl = `${hostApi}/containers/${_this.tenantId}/download/${filename}`;
                
                // Crear objeto de archivo
                var fileObj = {
                    fileName: file.name,
                    fileUrl: fileUrl,
                    filename: filename
                };
                
                // Asegurarse de que model sea un array antes de hacer push
                if (!Array.isArray(_this.model)) {
                    _this.model = [];
                }
                
                // Agregar al array
                _this.filesList.push(fileObj);
                _this.model.push({uri:fileUrl, name:file.name});
                
                _this.isUploading = false;
                
                toast.success("Archivo subido correctamente.");
            }, function (err) {
                console.error("Error al subir archivo", err);
                toast.error("Error al subir el archivo.");
                _this.isUploading = false;
            });
        };

        this.removeFile = function (index) {
            if (index === undefined || index < 0 || index >= _this.filesList.length) {
                return;
            }

            // Asegurarse de que model sea un array antes de hacer splice
            if (!Array.isArray(_this.model)) {
                _this.model = [];
            }

            // Eliminar del array (no se elimina del servidor, solo se quita del array)
            _this.filesList.splice(index, 1);
            _this.model.splice(index, 1);
            
            toast.success("Archivo eliminado.");
        };

        this.downloadFile = function (fileObj) {
            if (!fileObj || !fileObj.fileUrl) {
                return;
            }
            
            // Intentar obtener docToken primero, si no existe usar access_token de LoopBack
            const docToken = Authentication.currentDocToken();
            let downloadUrl = fileObj.fileUrl;
            
            // Agregar access_token como query parameter al final de la URL si existe
            downloadUrl = fileObj.fileUrl + '?access_token=' + docToken;

            // Descargar archivo usando blob (similar a gridDocsDirective)
            $http({
                method: 'GET',
                url: downloadUrl,
                responseType: 'blob'
            }).then(function (response) {
                let blob = new Blob([response.data], { type: response.headers('Content-Type') || 'application/octet-stream' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileObj.fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }, function (error) {
                console.error('Error descargando el archivo:', error);
                toast.error("No se pudo descargar el archivo: " + fileObj.fileName);
            });
        };
    }
];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            item: '=',
            model: '='
        },
        controller: docsValidateCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/docsValidateDirective.html'
    };
};